module.exports = __webpack_public_path__ + "img/1498115385.d7737b6f.jpg";